import { GAME_ID, REDUX_ACTIONS, ITEM_PART, LEVEL_COUNT } from '../../data/constants';

const initState = {
  levelIndex: 0,
  questionIndex: 0,
  clues: [],
  isCurrentItemFailed: false,
  selectedTrapId: undefined,
  isSelectingTrap: false,
  traps: [],
  trapSelectionOrder: [],
  itemPart: ITEM_PART.INFERENCE,
  highestLevelUnlocked: 0,
  introText: '',
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_LEVEL:
      return {
        ...state,
        questionIndex: payload.questionIndex,
        clues: payload.clues,
        levelIndex: payload.levelIndex,
        selectedTrapId: undefined,
        isSelectingTrap: false,
        traps: payload.traps,
        trapSelectionOrder: [],
      };

    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM: {
      const nextFoundIndex = state.clues.filter(clue => clue.isFound).length;
      return {
        ...state,
        itemPart: ITEM_PART.INFERENCE,
        clues: state.clues.map((clue, index) =>
          (payload.itemIndex === index && !clue.isFound ?
            { ...clue, isFound: true, foundIndex: nextFoundIndex }
            :
            clue)),
        isCurrentItemFailed: false,
      };
    }

    case REDUX_ACTIONS.SET_INTRO_TEXT:
      return {
        ...state,
        introText: payload.text,
      };

    case REDUX_ACTIONS.MARK_ITEM_AS_COMPLETE:
      return {
        ...state,
        clues: state.clues.map((clue, index) => (payload.index === index ? { ...clue, isComplete: true } : clue)),
        questionIndex: state.questionIndex + 1,
      };

    case REDUX_ACTIONS.FAIL_STD_ITEM:
      return {
        ...state,
        clues: state.clues.map((clue, index) => (payload.index === index ? { ...clue, isFailed: true } : clue)),
        questionIndex: state.questionIndex + 1,
        isCurrentItemFailed: true,
      };

    case REDUX_ACTIONS.SET_TRAP: {
      const selectedTrap = { ...state.traps.find(e => e.id === payload) };
      delete selectedTrap.isFailed;
      return {
        ...state,
        selectedTrapId: payload,
        trapSelectionOrder: [...state.trapSelectionOrder, selectedTrap],
      };
    }

    case REDUX_ACTIONS.SET_IS_SELECTING_TRAP:
      return {
        ...state,
        isSelectingTrap: true,
      };

    case REDUX_ACTIONS.SET_ITEM_PART:
      return {
        ...state,
        itemPart: payload.nextPart,
        questionIndex: state.questionIndex + 1,
      };

    case REDUX_ACTIONS.FAIL_TRAP:
      return {
        ...state,
        traps: state.traps.map(trap => (trap.id === payload ? { ...trap, isFailed: true } : trap)),
      };

    case REDUX_ACTIONS.COMPLETE_LEVEL:
      return {
        ...state,
        highestLevelUnlocked: Math.min(Math.max(payload.levelIndex + 1, state.highestLevelUnlocked), LEVEL_COUNT - 1),
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
